import { MetaPropertyName } from 'vue-meta';

export const NoRobots: MetaPropertyName = {
  name: 'robots',
  content: 'noindex,nofollow',
};
